import { Component, Input, OnInit, Inject, NgZone } from "@angular/core";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyHttp } from "../../../../../tsScripts/providers/http/CompanyHttp";
import { MessageStorage } from "../../../../../tsScripts/util/MessageStorage";
import { ActivatedRoute } from "@angular/router";

@Component({
    templateUrl: "../../../../../views/components/support/companies/profile/modalDeleteProfile.html",
    providers: [CompanyHttp]
})
export class ModalDeleteProfile implements OnInit {

    @Input()
    selected: any[];

    private companyId: string;

    errorMessage: string;

    loading: boolean;

    isForce;

    constructor(private zone: NgZone,
        private CompanyHttp: CompanyHttp,
        private routeLocation: ActivatedRoute,
        private activeModal: NgbActiveModal) {
        this.errorMessage = "";
        this.companyId = this.routeLocation.snapshot.queryParams.companyId;
    }

    closeModal() {
        this.activeModal.close();
    }

    deleteProfiles() {
        this.zone.run(() => {
            this.deleteProfileZone();
        });
    }
    public deleteProfile;
    deleteProfileZone() {
        //this.loading=true;
        let listProfileToDelete: any[] = [];

        for (let profile of this.selected) {
            listProfileToDelete.push(profile.registerId);
        }
        this.deleteProfile = {
            "companyId": this.companyId,
            "registersId": listProfileToDelete,
            "force": ModalDeleteProfile.formatProcessForce(this.isForce)
        };
        this.CompanyHttp.deleteProfiles(this.deleteProfile).then(() => {

            if (this.selected.length > 1) {
                MessageStorage.add("success", "Perfiles eliminados correctamente");
            } else if (this.selected.length == 1) {
                MessageStorage.add("success", "El perfil " + this.selected[0].profileName + " fue eliminado correctamente");
            }

            //this.loading=false;
            this.activeModal.dismiss();
        }, (error) => {

            this.errorMessage = error.errorMessage;
            //this.loading=false;
        });
    }

     public static formatProcessForce(active): string {
        let forceFormated;
        switch (active) {

            case true:
                forceFormated = "1";
                break;

            case false:
                forceFormated = "0";
                break;
        }
        return forceFormated;

    }

    ngOnInit() {

    }
}